export default "__VITE_ASSET__jNIr2AGJ__"